import { Routes } from '@angular/router';
import { RequestListComponent } from './pages/request-list/request-list.component';
import { RequestNewComponent } from './pages/request-new/request-new.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DetailComponent } from './pages/detail/detail.component';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { StatisticsComponent } from './pages/statistics/statistics.component';
import { ContextComponent } from './pages/context/context.component';
import { cotGuard } from './guards/cot.guard';
import { PrintComponent } from './pages/print/print.component';
import { ModelsComponent } from './pages/models/models.component';
import { DashboardMmgComponent } from './pages/dashboard-mmg/dashboard-mmg.component';
import { MonitorComponent } from './pages/monitor/monitor.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
  }, 
  {
    path: 'context',
    component: ContextComponent,
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'dashboard-mmg',
    component: DashboardMmgComponent,
    // canActivate: [authGuard, cotGuard],
  },
  {
    path: 'request-list',
    component: RequestListComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'request-new',
    component: RequestNewComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'models',
    component: ModelsComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'monitor',
    component: MonitorComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'statistics',
    component: StatisticsComponent,
    canActivate: [authGuard, cotGuard],
  },
  {
    path: 'detail/:uuid',
    component: DetailComponent,
    canActivate: [authGuard, cotGuard],
  },
    {
    path: 'print',
    component: PrintComponent,
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
